module.exports = __webpack_public_path__ + "img/蒋红红.08631b81.jpg";